import type { ClassGroupsTableState } from './types';

const selectClassGroupsTableState = (state: { classGroupsTable: ClassGroupsTableState }) =>
  state.classGroupsTable;

export const classGroupsTableSelectors = {
  getState: selectClassGroupsTableState,
  getRequest: (state: { classGroupsTable: ClassGroupsTableState }) =>
    selectClassGroupsTableState(state).request,
};
